<!-- Sidebar: grouped navigation and data status. -->
<script lang="ts">
  import { app } from "../lib/state.svelte";
  const NAV: [string, [string, string][]][] = [
    ["Przegląd", [["dashboard", "Pulpit"], ["holdings", "Pozycje"], ["allocation", "Alokacja i waluty"]]],
    ["Wyniki", [["performance", "Wyniki i ryzyko"], ["returns", "Zwroty i inflacja"], ["attribution", "Skąd wziął się zysk"], ["purchases", "Opłacalność zakupów"]]],
    ["Planowanie", [["bonds", "Kalendarz obligacji"], ["ike", "IKE i IKZE"], ["projection", "Prognoza"], ["alternative", "Portfel vs EDO i lokata"]]],
    ["Podatki i koszty", [["taxes", "Podatki (Belka)"], ["costs", "Koszty"], ["cashflows", "Wpłaty i dochody"]]],
    ["Dane", [["transactions", "Transakcje"], ["import", "Import i dane"], ["settings", "Ustawienia"]]],
  ];
  const generated = $derived(app.market?.generated ? app.market.generated.replace("T", " ").slice(0, 16) : "–");
  const home = typeof location === "undefined" ? "/" : location.pathname;
</script>

<aside class="side">
  <div class="brand"><span class="logo"></span>Portfel</div>
  <nav id="nav">
    {#each NAV as [group, links] (group)}
      <div class="nav-group">{group}</div>
      {#each links as [view, label] (view)}
        <a href="#/{view}" data-view={view} class:active={app.screen === "app" && app.route === view}>{label}</a>
      {/each}
    {/each}
  </nav>
  <div class="side-foot" id="status">
    {#if app.status !== null}{app.status}{:else if app.model && app.data}
      {app.data.transactions.length} transakcji · {app.model.accounts.length} rachunki<br />notowania: {generated}
      {#if app.fs}<br /><a href={home} class="folder-link" title="Wybierz inny folder albo wyjdź z trybu demo">{app.fs.kind === "demo" ? "▶ dane demo · wyjdź" : `📁 ${app.fs.name} · zmień`}</a>{/if}
    {/if}
  </div>
</aside>
